export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.sys-manager': 'System Management',
  'menu.sys-manager.user-list': 'User List',
  'menu.sys-manager.role': 'Role Management',
  'menu.sys-manager.department': 'Department Management',
  'menu.sys-manager.menu': 'Menu Management',
  'menu.sys-manager.data-permission': 'Data Permission',
  'menu.sign-template': 'Template Management',
  'menu.sign-template.template-sign': 'Sign Template',
  'menu.sign-template.template-video': 'Video Template',
  'menu.sign-template.template-file': 'File Template',
  'menu.sign-template.template-file-edit': 'Document Editor',
  'menu.sign-template.tag': 'Variable Management',
  'menu.sign-process': 'Sign Process Management',
  'menu.sign-manage': 'Sign Management',
  'menu.sign-manage.published-sign': 'Published Signs',
  'menu.sign-auth': 'Sign Authorization',
  'menu.sign-auth.publish-auth': 'Publish Authorization',
  'menu.sign-auth.draft-box': 'Draft Box',
  'menu.sign-auth.published': 'Published',
  'menu.sign-auth.published-detail': 'Publish Detail',
  'menu.sign-auth.archived': 'Archived',
  'menu.sign-auth.archived-detail': 'Archive Detail',
  'menu.sign-auth.auth-manage': 'Authorization Management',
  'menu.seal-manage': 'Seal Management',
  'menu.seal-manage.seal-company': 'Company Seal',
  'menu.data-stat': 'Usage Statistics',
  'menu.data-stat.cfca24-verify': 'Two/Four Elements',
  'menu.data-stat.sign-stat': 'Sign Statistics',
};
